/* 空白用 */
import React from 'react';
import { Form, Col } from 'react-bootstrap';

const Blank: React.FC = () => {
  return (
    <Form.Row>
      <Col md={4} className="field-label-blank" />
      <Col md={8} className="field-label-text-blank" />
    </Form.Row>
  );
};

export default Blank;
